export type BuildViewParam = "overview" | "map" | "matrix" | "split" | "write";

/** Smart default: first visit (zero claims) lands on Overview, returning
 *  users land on Map (canvas-first). Explicit ?view= always wins. Returns
 *  null while the claims query is still resolving so the route renders a
 *  quiet placeholder instead of flashing the wrong view. */
export function effectiveBuildView(
  viewParam: BuildViewParam | undefined,
  claimCount: number | undefined,
): BuildViewParam | null {
  if (viewParam) return viewParam;
  if (claimCount === undefined) return null;
  return claimCount === 0 ? "overview" : "map";
}
